import isString from 'lodash/isString';
import { transformString, trimString } from './utils';
export default function formatString(value, { trim, format }) {
    if (isString(value)) {
        return transformString(trimString(value, trim), format);
    }
    return value;
}
